const googleMap = {
  methods: {
    setLocationCenter(lat, lng, zoom = 18) {
      window.googleMap.setZoom(zoom)
      window.googleMap.panTo({ lat, lng })
    },
    async myLocation() {
      try {
        const position = await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject)
        })
        const { longitude, latitude } = position.coords
        return { lat: latitude, lng: longitude }
      } catch (e) {
        return { error: true, message: e }
      }
    },
    async setMyLocation() {
      try {
        const { error, lat, lng } = await this.myLocation()
        if (error) {
          this.openModelPositionError = true
          return
        }
        const myAreas = this.findMyPolygon(
          lat,
          lng,
          this.$store.getters.areas,
        )
        const myPoint =
          lng && lat
            ? {
              type: "myLocation",
              _id: "myLocation",
              name: "אתה כאן",
              location: {
                coordinates: [lat, lng],
              },
              areas:[myAreas?._id],
              icon: "/assets/markerLightGreen.png",
            }
            : null
        this.$store.commit("point/set", myPoint)
        this.$store.commit("myPoint/set", myPoint)
      } catch (e) {
        this.openModelPositionError = true
      }
    },
    findMyPolygon(lng, lat, areas) {
      let myArea = null
      areas.forEach(area => {
        const coordinate = this.makeGoogleLatLngAltitude(lng, lat)
        const areaCoords = this.coordsFormatterGoogleMap(
          area.location.coordinates[0],
        )
        const polygon = new this.google.maps.Polygon({
          paths: areaCoords,
        })
        if (this.isInPolygon({ coordinate, polygon })) {
          myArea = area
        }
      })
      return myArea
    },
    makeGoogleLatLngAltitude(lat, lng) {
      return new this.google.maps.LatLng(+lat, +lng)
    },
    coordsFormatterGoogleMap(array) {
      return array.map((c) => ({ lat: c[1], lng: c[0] }))
    },
    isInCircle({ pointOne, pointTwo, radius }) {
      let distanceBetweenTwoPointsKM =
        window.google.maps.geometry.spherical.computeDistanceBetween(
          pointOne,
          pointTwo,
        )
      distanceBetweenTwoPointsKM = Math.ceil(distanceBetweenTwoPointsKM) / 1000
      return distanceBetweenTwoPointsKM < radius
    },
    isInPolygon({ polygon, coordinate }) {
      return this.google.maps.geometry.poly.containsLocation(
        coordinate,
        polygon,
      )
    },
    setRadiusCircle(point) {
      const circleOnMap = this.$store.getters.circleOnMapInstance
      const radius = this.$store.getters.currentRadius
      if (circleOnMap) {
        circleOnMap.setMap(null)
      }
      const circle = new window.google.maps.Circle({
        map: window.googleMap,
        radius: radius * 1000,
        fillColor: "#876109",
      })
      circle.bindTo("center", point, "position")
      this.$store.commit("point/setCircleOnMapInstance", {
        circleOnMapInstance: circle,
      })
      this.removePointFromRadius(radius)
    },
    removePointFromRadius(radius) {
      const points = this.$store.getters.pointsInRadius

      const [lat, lng] = this.$store.getters?.point?.location?.coordinates
      const newPoints = points.filter((point) => {
        const pointOneCoord = point.location.coordinates
        return this.isInCircle({
          pointOne: { lat: pointOneCoord[0], lng: pointOneCoord[1] },
          pointTwo: { lat, lng },
          radius,
        })
      })
      if (points.length === newPoints.length) return
      this.$store.commit("point/setPointsInRadius", newPoints)
    },
    async getPointsInRadius(point) {
      const [lat, lng] = point?.location?.coordinates

      await this.$store.dispatch("point/indexPointsInRadius", {
        radius: 5,
        lat,
        lng,
        toastOptions:{disabled:true}
      })
    },
    async setMeToLocation(point) {
      this.$store.getters?.circleOnMapInstance?.setMap(null)
      const [lat, lng] = point?.location?.coordinates
      this.$store.commit("point/set", point)
      await this.getPointsInRadius(point)
      this.setLocationCenter(lat, lng)
      this.insertInHistory(point._id)
    },
    insertInHistory(id) {
      let history = localStorage.getItem("search history")
      if (history) {
        history = JSON.parse(localStorage.getItem("search history"))
      } else {
        localStorage.setItem("search history", JSON.stringify([id]))
      }
      const index = history.findIndex((_id) => _id === id)
      let search = [id, ...history]
      if (history && index === -1) {
        search = [id, ...history]
      } else {
        history.splice(index, 1)
        search = [id, ...history]
      }
      localStorage.setItem("search history", JSON.stringify(search))
    },
  },
}

export default googleMap
